__webpack_require__.p = "https://nx-busapplication-qa.azureedge.net/app/";